<template>
    <div class="confirm-overlay" v-if="props.visible">
      <div class="confirm-modal">
        <div class="confirm-header">
          <h5>{{ props.title }}</h5>
          <button class="close-btn" @click="handleCancel">&times;</button>
        </div>
        <div class="confirm-body">
          <p>{{ props.message }}</p>
        </div>
        <div class="confirm-footer">
          <button class="btn cancel" @click="handleCancel">{{ props.cancelText }}</button>
          <button class="btn confirm" @click="handleConfirm">{{ props.confirmText }}</button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  // import { defineProps, defineEmits } from 'vue';
  
  const props = defineProps({
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'Confirmação' },
    message: { type: String, default: '' },

    // ✅ NOVO: textos dos botões
    cancelText: { type: String, default: 'Cancelar' },
    confirmText: { type: String, default: 'Confirmar' },
  });

  const emit = defineEmits(['confirm', 'cancel']);
  
  function handleConfirm() {
    emit('confirm');
  }
  
  function handleCancel() {
    emit('cancel');
  }
  </script>
  
  <style scoped>
  .confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .confirm-modal {
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    max-width: 400px;
    width: 90%;
    z-index: 10000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
  
  .confirm-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .close-btn {
    background: transparent;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    line-height: 1;
  }
  
  .confirm-body {
    margin: 20px 0;
    font-size: 0.9rem;

  }
  
  .confirm-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 6px 8px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    font-size: 0.9rem;
  }
  
  .btn.cancel {
    background: #6c757d;
    color: #fff;
  }
  
  .btn.confirm {
    background: #007bff;
    color: #fff;
  }
  </style>
  